import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FaStar key={i} color={i <= rating ? '#f7d9a8' : '#ddd'} />
      );
    }
    return stars;
  };

  return (
    <div className="product-card">
      {product.isNew && <span className="badge-new">Neu</span>}
      <Link to={`/product/${product.id}`}>
        <img src={product.image} alt={product.name} className="product-card-img" />
      </Link>
      <div className="product-card-body">
        <Link to={`/product/${product.id}`} style={{ textDecoration: 'none' }}>
          <h3>{product.name}</h3>
        </Link>
        <div className="rating">{renderStars(product.rating)}</div>
        <p>{product.shortDesc}</p>
        <div className="product-price">{product.price.toFixed(2)} €</div>
        <button onClick={() => addToCart(product)} className="btn btn-primary btn-sm">
          <FaShoppingCart /> In den Warenkorb
        </button>{' '}
        <Link to={`/product/${product.id}`} className="btn btn-ghost btn-sm">
          Details
        </Link>
      </div>
    </div>
  );
}